import i18n from '@/config/i18n'

// TODO Enumフォーマット処理共通化
const formatDeliveryTimeSlot: (status: number) => string = (status: number) => {
  switch (status) {
    case 0:
      return i18n.tc('enums.deliverytimeslot.slotNone')
    case 1:
      return i18n.tc('enums.deliverytimeslot.slotAM')
    case 3:
      return i18n.tc('enums.deliverytimeslot.slot1416')
    case 4:
      return i18n.tc('enums.deliverytimeslot.slot1618')
    case 5:
      return i18n.tc('enums.deliverytimeslot.slot1820')
    case 7:
      return i18n.tc('enums.deliverytimeslot.slot1921')
    default:
      return i18n.tc('enums.unknown')
  }
}

export default formatDeliveryTimeSlot
